import React from 'react';
import { styles } from '../AuthWrapper.styles';
import type { AuthFormState } from '../../hooks/useAuthForm';

const ResetRequestForm: React.FC<{ form: AuthFormState }> = ({ form }) => {
  const { email, setEmail, isSubmitting, handleResetPasswordRequest, setAuthMode } = form;

  return (
    <form onSubmit={handleResetPasswordRequest} style={styles.form}>
      <p style={styles.confirmText}>
        Enter your email address and we'll send you a verification code to reset your password.
      </p>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <button
        type="submit"
        style={{
          ...styles.button,
          ...(isSubmitting ? styles.buttonDisabled : {}),
        }}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Sending code...' : 'Send Reset Code'}
      </button>
      <button
        type="button"
        style={styles.linkButton}
        onClick={() => {
          setAuthMode('signin');
        }}
      >
        Back to Sign In
      </button>
    </form>
  );
};

export default ResetRequestForm;
